import {
  call, put, select, takeEvery, takeLeading,
} from 'redux-saga/effects';
import {
  apiAddHandler,
  apiFetchAllHandlers,
  apiFetchMrdDeviceListByCountry,
  apiFetchMrdHandlers,
} from '../../api/HandlersAPI';
import { apiCopyHandler } from '../../copy-handlers/api/HandlerCopyAPI';
import { apiEditHandlers } from '../../edit-handlers/api/HandlersEditAPI';
import {
  postCopyHandlerSuccessActionCreator,
  postCopyHandlerFailureActionCreator,
  getMrdByCountrySuccessActionCreator,
  getMrdByCountryFailureActionCreator,
  putEditHandlersSuccessActionCreator,
  putEditHandlersFailureActionCreator,
  getAllHandlersSuccessActionCreator,
  getAllHandlersFailureActionCreator,
  getHandlersByMrdSuccessActionCreator,
  getHandlersByMrdFailureActionCreator,
  postAssociateHandlerSuccessActionCreator,
  postAssociateHandlerFailureActionCreator,
  postCreateNewHandlerFailureActionCreator,
  postCreateNewHandlerSuccessActionCreator,
} from '../actions/HandlersActions';
import {
  COPY_HANDLERS_REQUEST,
  GET_ALL_HANDLERS_REQUEST,
  GET_HANDLERS_BY_MRD_REQUEST,
  GET_MRD_BY_COUNTRY_REQUEST,
  EDIT_HANDLERS_REQUEST,
  ASSOCIATE_NEW_HANDLERS_REQUEST,
  CREATE_NEW_HANDLER_REQUEST,
} from '../actions/types/HandlersActionTypes';
import { showNotification } from '../../../../../common/notifications/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../locales/locales';
import { languageSelector } from '../../../../../common/redux/selectors/languageSelector';
import { apiAssociateHandler } from '../../associate-handlers/api/HandlerAssociateAPI';

function* postCopyHandlerWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiCopyHandler, action.payload);
    yield put(postCopyHandlerSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.handlers.copy.success'),
    }));
  } catch (error) {
    yield put(postCopyHandlerFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error?.response?.data?.message || 'request failed',
    }));
  }
}

function* putEditHandlerWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiEditHandlers, action.payload);
    yield put(putEditHandlersSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.handlers.edit.success'),
    }));
  } catch (error) {
    yield put(putEditHandlersFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error?.response?.data?.message || 'request failed',
    }));
  }
}

function* getMrdByCountryWorker(action) {
  try {
    const res = yield call(apiFetchMrdDeviceListByCountry, action.payload);
    yield put(getMrdByCountrySuccessActionCreator(res.data));
  } catch (error) {
    yield put(getMrdByCountryFailureActionCreator(error));
  }
}

function* getAllHandlersWorker(action) {
  try {
    const res = yield call(apiFetchAllHandlers, action.payload);
    yield put(getAllHandlersSuccessActionCreator(res.data));
  } catch (error) {
    yield put(getAllHandlersFailureActionCreator(error));
  }
}

function* getHandlersByMrdWorker(action) {
  try {
    const res = yield call(apiFetchMrdHandlers, action.payload);
    yield put(getHandlersByMrdSuccessActionCreator(res.data));
  } catch (error) {
    yield put(getHandlersByMrdFailureActionCreator(error));
  }
}

function* handlerAssociateWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiAssociateHandler, action.payload);
    yield put(postAssociateHandlerSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.handlers.associate.success'),
    }));
  } catch (error) {
    yield put(postAssociateHandlerFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error.response.data.message || formatMessage(lang, 'notification.handlers.associate.failure'),
    }));
  }
}

function* postHandlerWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiAddHandler, action.payload);
    yield put(postCreateNewHandlerSuccessActionCreator(res.data));
  } catch (error) {
    yield put(postCreateNewHandlerFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error.response.data.message || formatMessage(lang, 'notification.mrd.handler.failure'),
    }));
  }
}

function* handlerWatcher() {
  yield takeLeading(COPY_HANDLERS_REQUEST, postCopyHandlerWorker);
  yield takeEvery(GET_MRD_BY_COUNTRY_REQUEST, getMrdByCountryWorker);
  yield takeEvery(GET_ALL_HANDLERS_REQUEST, getAllHandlersWorker);
  yield takeLeading(EDIT_HANDLERS_REQUEST, putEditHandlerWorker);
  yield takeEvery(GET_HANDLERS_BY_MRD_REQUEST, getHandlersByMrdWorker);
  yield takeLeading(ASSOCIATE_NEW_HANDLERS_REQUEST, handlerAssociateWorker);
  yield takeLeading(CREATE_NEW_HANDLER_REQUEST, postHandlerWorker);
}
export default handlerWatcher;

export {
  postCopyHandlerWorker,
  getMrdByCountryWorker,
  putEditHandlerWorker,
  getAllHandlersWorker,
  getHandlersByMrdWorker,
  handlerAssociateWorker,
  postHandlerWorker,
};
